import { FC } from "react";
import { useTranslation } from "react-i18next";
import RulesContentEN from "./content.en";
import RulesContentTH from "./content.th";
import RulesContentCN from "./content.cn";

/**
 * Renders the Sports Betting Rules content in the active language,
 * falling back to English.
 */
const RulesContent: FC = () => {
  const { i18n } = useTranslation();

  switch (i18n.language) {
    case "th":
      return <RulesContentTH />;
    case "cn":
      return <RulesContentCN />;
    default:
      return <RulesContentEN />;
  }
};

export default RulesContent;
